import axios from 'axios';
import qs from 'qs'
// import qs from 'qs';//转换请求参数格式，需要时使用
axios.defaults.baseURL = 'https://speapp.zipaicefuqi.com/';
axios.defaults.timeout = 500000;
// if(window.localStorage.getItem('userInfo')){
//     axios.defaults.headers.common['authorization'] = 'Bearer ' + JSON.parse(window.localStorage.getItem('userInfo')).access_token
// }

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么，例如加入token
    //config.headers.Authorization = '123';
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 在接收响应做些什么，例如跳转到登录页
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url,params){
    return new Promise((resolve, reject) => {
        const obj = {
            uid: window.localStorage.getItem('uid')?window.localStorage.getItem('uid'): '',//浏览人UID
            ver: '1.0.0', //版本号
            xcx_id: 7, //请求ID
            token:window.localStorage.getItem('token')?window.localStorage.getItem('token') : '',
            unionid: window.localStorage.getItem('unionid')?window.localStorage.getItem('unionid') : ''
        }

        axios.post(url, qs.stringify({...obj,...params}))
            .then(response => {
                
                resolve(response);
            }, err => {
                this.$message.error('服务器异常，请重试');
                reject(err);
            })
            .catch((error) => {
                
                reject(error)
            });
    });
}

//返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        const obj = {
            uid: window.localStorage.getItem('uid')?window.localStorage.getItem('uid'): '',//浏览人UID
            ver: '1.0.0', //版本号
            xcx_id: 7, //请求ID
            token:window.localStorage.getItem('token')?window.localStorage.getItem('token') : '',
            unionid: window.localStorage.getItem('unionid')?window.localStorage.getItem('unionid') : ''
        }
        axios.get(url, {params: {...obj,...param }})
            .then(response => {
                // if(response.data.code == '404'){
                //     console.log('404')
                //     return
                // }
                resolve(response)
            }, err => {
                this.$message.error('服务器异常，请重试');
                reject(err)
            })
            .catch((error) => {
                
                reject(error)
            })
    })
}
export default {
    fetchGet,
    fetchPost
}


// WEBPACK FOOTER //
// ./src/https.js